import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { Layout } from '../components/Layout/Layout';
import { useNavigation } from '../hooks/useNavigation';
import { Button } from '../components/common/Button';
import LogClick from '../components/common/LogClick';
import { LogoBox } from '../components/common/LogoBox';
import Setting from '../components/common/Setting';
// import LanguageSelector from '../components/LanguageSelector'; // UI 제거 (기능은 유지)
import HomeButton from '../components/common/HomeButton';
import { reissueToken } from '../service/api.v2.service/auth';
import { useDispatch } from 'react-redux';
import { setErrorMessage } from '../store/errorSlice';
import { reportError, reportTokenSuccess } from '../utils/errorReporting';
import { getTokens } from '../utils/util';

export function StartPage() {
  const { t } = useTranslation();
  const { navigateToTheme } = useNavigation();
  const dispatch = useDispatch();

  const handleStartClick = async () => {
    try {
      await reissueToken();

      const savedTokens = getTokens();
      reportTokenSuccess('토큰 재발급 성공', {
        message: 'StartPage: Token reissued successfully',
        accessToken: savedTokens.accessToken ? 'exists' : 'missing',
        refreshToken: savedTokens.refreshToken ? 'exists' : 'missing',
        timestamp: new Date().toISOString(),
      });

      navigateToTheme();
    } catch (error) {
      reportError(error, {
        message: 'StartPage: Token reissue failed',
        timestamp: new Date().toISOString(),
      });

      dispatch(
        setErrorMessage({
          errorMessage: t('start.error.expired'),
          errorContent: t('start.error.retry'),
          messageDuration: 3000,
        })
      );

      setTimeout(() => {
        window.location.href = '/otp';
      }, 3000);
    }
  };

  return (
    <Layout>
      {/* <LanguageSelector /> */} {/* UI 제거 (기능은 유지) */}
      <HomeButton />
      <Container>
        <Setting />
        <LogoBox />
        <ButtonWrapper>
          <LogClick params={{ key: 'start' }}>
            <Button onClick={handleStartClick}>{t('start.start')}</Button>
          </LogClick>
          {/* <a
            href="https://projectbuildup.notion.site/137bfe76a03a80c09fd6d29dde9266ee?pvs=4"
            target="blank"
          >
            프로젝트빌드업 셀프 포토 스튜디오 알아보기
          </a> */}
        </ButtonWrapper>
      </Container>
    </Layout>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1280px;
  max-height: 773px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 80px;
  flex-direction: column;

  > a {
    color: ${({ theme }) => theme.color[2]};
    ${({ theme }) => theme.typography.REGULAR_16};
    text-align: center;
    margin-top: 20px;
    text-decoration: underline;
  }
`;
